import { useQuery } from '@tanstack/react-query';
import {
  emptyCustomerListFilters,
  quotationsListPicAssigneeKey,
  quotationsListPicAssigneeReady,
  strapiListCustomers,
  type CustomerListFilters,
  type QuotationsListPicAssignee,
} from '../../api/strapiCrm';
import { queryKeys } from '../queryKeys';

/** Ringkasan / dropdown: halaman pertama, hingga 200 baris (total meta tetap akurat). */
export function useCustomersQuery(
  jwt: string | null,
  filters: CustomerListFilters = emptyCustomerListFilters,
) {
  return useQuery({
    queryKey: queryKeys.customers(jwt, filters),
    queryFn: () => strapiListCustomers(jwt!, { filters, page: 1, pageSize: 200 }),
    enabled: Boolean(jwt),
  });
}

/** Daftar pelanggan dengan pagination server (selaras total Strapi vs DataGrid). */
export function useCustomersListQuery(
  jwt: string | null,
  filters: CustomerListFilters,
  page: number,
  pageSize: number,
  options?: { picAssignee?: QuotationsListPicAssignee | null },
) {
  const restrictToAssignedQuotations = options != null;
  const picAssignee = options?.picAssignee;
  const picReady =
    !restrictToAssignedQuotations || quotationsListPicAssigneeReady(picAssignee);
  return useQuery({
    queryKey: queryKeys.customersPage(
      jwt,
      filters,
      page,
      pageSize,
      restrictToAssignedQuotations ? quotationsListPicAssigneeKey(picAssignee) : null,
    ),
    queryFn: () =>
      strapiListCustomers(jwt!, {
        filters,
        page,
        pageSize,
        picAssignee: restrictToAssignedQuotations ? picAssignee : undefined,
      }),
    enabled: Boolean(jwt) && picReady,
  });
}
